import { rem } from 'design-system';
import { FETCH_APP_DATA, FETCH_APP_DATA_COMPLETE, FETCH_DASHBOARD_MODAL_STACK, HOLD_APP_OPEN_MODALS, } from 'actions/refresh';
import { CLEAR_PENDING_DEEPLINK, CLEAR_RE_ENABLED_TAB, CONNECTION_CHANGE_HANDLED, GET_MONTHLY_TOTALS_SUCCESS, LOGGED_OUT, MONTHLY_CATEGORIES_SUCCESS, REFRESH_ON_START, SET_DID_OPEN_TAB_IN_CURRENT_SESSION, SET_PENDING_DEEPLINK, SET_RE_ENABLED_TAB, SET_SIDEBAR_WIDTH, UPDATE_PREFERENCES_FAILURE, UPDATE_PREFERENCES_REQUEST_TIMESTAMP, UPDATE_PREFERENCES_SUCCESS, } from 'actions/types';
import { sortMonthlyTotals } from 'features/budgeting/selectors';
const DEFAULT_SIDEBAR_WIDTH = rem(180);
export const initialState = {
    isRefreshingApp: true,
    appOpenModalsHeld: false,
    /**
     * This flag prevents the duplicate calls for onBankAdd listeners
     * This flag is reset on ChooseBank mount
     * Sets after one of the listeners handles the add bank connection
     */
    connectionChangeHandled: false,
    lastLoggedInTimestamp: undefined,
    lastLoggedOutTimestamp: undefined,
    updatingPreferencesTimestamp: null,
    sidebarWidth: DEFAULT_SIDEBAR_WIDTH,
    /**
     * pendingDeeplink key is used to store a deeplink (from OneLink or an in-app webview) until the user is logged in
     * it is then handled in useDeeplinks for navigation/other actions
     */
    pendingDeeplink: undefined,
    budgetingCategories: undefined,
    monthlyTotalsForLatestPeriod: undefined,
};
const unpersistedUtils = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_APP_DATA: {
            return {
                ...state,
                isRefreshingApp: true,
            };
        }
        case REFRESH_ON_START: {
            return {
                ...state,
                isRefreshingApp: true,
                didOpenTabInCurrentSession: {},
            };
        }
        case SET_DID_OPEN_TAB_IN_CURRENT_SESSION: {
            return {
                ...state,
                didOpenTabInCurrentSession: {
                    ...state.didOpenTabInCurrentSession,
                    [action.tab]: true,
                },
            };
        }
        case FETCH_DASHBOARD_MODAL_STACK: {
            return {
                ...state,
                isRefreshingApp: true,
                appOpenModalsHeld: false,
            };
        }
        case HOLD_APP_OPEN_MODALS: {
            return {
                ...state,
                appOpenModalsHeld: true,
            };
        }
        case 'SET_LAST_LOGGED_OUT_TIMESTAMP_ACTION': {
            return {
                ...state,
                lastLoggedOutTimestamp: action.timestamp,
            };
        }
        case 'SET_LAST_LOGGED_IN_TIMESTAMP_ACTION': {
            return {
                ...state,
                lastLoggedInTimestamp: new Date().getTime(),
            };
        }
        case FETCH_APP_DATA_COMPLETE: {
            return {
                ...state,
                isRefreshingApp: false,
            };
        }
        case CONNECTION_CHANGE_HANDLED: {
            return {
                ...state,
                connectionChangeHandled: action.payload.status,
            };
        }
        case UPDATE_PREFERENCES_REQUEST_TIMESTAMP:
            return {
                ...state,
                updatingPreferencesTimestamp: action.extra.timestamp,
            };
        case UPDATE_PREFERENCES_SUCCESS:
            if (state.updatingPreferencesTimestamp &&
                action.extra.timestamp !== state.updatingPreferencesTimestamp) {
                // don’t reset updatingPreferencesTimestamp as there will be a new request
                return state;
            }
            return { ...state, updatingPreferencesTimestamp: null };
        case UPDATE_PREFERENCES_FAILURE:
            return { ...state, updatingPreferencesTimestamp: null };
        case SET_SIDEBAR_WIDTH:
            return { ...state, sidebarWidth: action.payload };
        case SET_PENDING_DEEPLINK: {
            return {
                ...state,
                pendingDeeplink: action.link,
            };
        }
        case CLEAR_PENDING_DEEPLINK: {
            return {
                ...state,
                pendingDeeplink: undefined,
            };
        }
        case GET_MONTHLY_TOTALS_SUCCESS: {
            const { withPreviousPlan } = action.extra;
            if (!withPreviousPlan) {
                return state;
            }
            const results = action.payload.totals;
            const resultsLen = results?.length;
            return {
                ...state,
                monthlyTotalsForLatestPeriod: results && resultsLen ? results[resultsLen - 1] : undefined,
            };
        }
        case MONTHLY_CATEGORIES_SUCCESS: {
            const { withPreviousPlan } = action.extra;
            if (!withPreviousPlan) {
                return state;
            }
            return {
                ...state,
                budgetingCategories: sortMonthlyTotals(action.payload.categories.filter((item) => item?.baseLimit != null &&
                    !item.parentCategoryId &&
                    item.canSetBudget)),
            };
        }
        case SET_RE_ENABLED_TAB: {
            return {
                ...state,
                reEnabledTab: action.tab,
            };
        }
        case CLEAR_RE_ENABLED_TAB: {
            return {
                ...state,
                reEnabledTab: null,
            };
        }
        case LOGGED_OUT: {
            return {
                ...state,
                reEnabledTab: null,
                isRefreshingApp: true,
                appOpenModalsHeld: false,
                pendingDeeplink: undefined,
                connectionChangeHandled: false,
                budgetingCategories: undefined,
                lastLoggedInTimestamp: undefined,
                didOpenTabInCurrentSession: undefined,
                monthlyTotalsForLatestPeriod: undefined,
            };
        }
        default: {
            return state;
        }
    }
};
export default unpersistedUtils;
